import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingpageComponent } from './components/landingpage/landingpage.component';

const routes: Routes = [
  {path:'', component: LandingpageComponent},
  {path:'**', pathMatch:'full', redirectTo:''}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,  {
    useHash: true,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
